import React from 'react';
import PropTypes from 'prop-types';
import reactCSS from 'reactcss';
import EditableInput from './EditableInput';

const CompactFields = ({ hex, rgb, onChange }) => {
	const styles = reactCSS({
		default: {
			fields: {
				borderTop: `1px solid #f2f2f2`,
				display: 'flex',
				paddingBottom: '6px',
				paddingRight: '5px',
				paddingTop: 8,
				position: 'relative'
			},
			active: {
				height: '15px',
				width: '27px',
				background: hex
			},
			HEXwrap: {
				flex: '6',
				position: 'relative'
			},
			HEXinput: {
				width: '80%',
				padding: '0px',
				paddingLeft: '8px',
				// border: 'none',
				borderWidth: 1,
				borderRadius: 4,
				borderColor: 'rgba(0,0,0,0.12)',
				outline: 'none',
				background: 'none',
				fontSize: '1rem',
				color: '#333',
				height: '1.8rem',
				marginLeft: 10
			},
			HEXlabel: {
				display: 'none'
			},
			RGBwrap: {
				flex: '3',
				justifyContent: 'center',
				alignItems: 'center',
				position: 'relative'
			},
			RGBinput: {
				width: '70%',
				padding: '0px',
				paddingLeft: 5,
				boxShadow: 'inset 0 0.0625em 0.125em rgba(10, 10, 10, 0.05)',
				// border: 'none',
				borderColor: 'rgba(0,0,0,0.12)',
				borderWidth: 1,
				borderRadius: 4,
				outline: 'none',
				background: 'none',
				fontSize: '1rem',
				color: '#333',
				height: '1.8rem',
				marginLeft: 18
			},
			RGBlabel: {
				position: 'absolute',
				top: '1px',
				left: '0px',
				lineHeight: '1.8rem',
				textTransform: 'uppercase',
				fontSize: '1rem',
				color: '#000'
			}
		}
	});
	// console.log('CompactField', rgb);
	const handleChange = (data, e) => {
		if (data.r || data.g || data.b) {
			onChange(
				{
					r: data.r || rgb.r,
					g: data.g || rgb.g,
					b: data.b || rgb.b,
					source: 'rgb'
				},
				e
			);
		} else {
			onChange(
				{
					hex: data.hex,
					source: 'hex'
				},
				e
			);
		}
	};

	return (
		<div style={styles.fields} className="flexbox-fix">
			<span style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
				<div style={styles.active} />
				<EditableInput
					label="hex"
					value={hex}
					inputProps={{
						maxLength: 7
					}}
					style={{
						wrap: styles.HEXwrap,
						input: styles.HEXinput,
						label: styles.HEXlabel
					}}
					onChange={handleChange}
				/>
			</span>
			<EditableInput
				style={{ wrap: styles.RGBwrap, input: styles.RGBinput, label: styles.RGBlabel }}
				label="r"
				value={rgb.r}
				inputProps={{
					max: 255,
					min: 0,
					maxLength: 3
				}}
				type="number"
				onChange={handleChange}
			/>
			<EditableInput
				style={{ wrap: styles.RGBwrap, input: styles.RGBinput, label: styles.RGBlabel }}
				label="g"
				value={rgb.g}
				type="number"
				inputProps={{
					max: 255,
					min: 0,
					maxLength: 3
				}}
				onChange={handleChange}
			/>
			<EditableInput
				style={{ wrap: styles.RGBwrap, input: styles.RGBinput, label: styles.RGBlabel }}
				label="b"
				inputProps={{
					max: 255,
					min: 0,
					maxLength: 3
				}}
				value={rgb.b}
				type="number"
				onChange={handleChange}
			/>
		</div>
	);
};

CompactFields.propTypes = {
	hex: PropTypes.string.isRequired,
	onChange: PropTypes.func.isRequired,
	rgb: PropTypes.shape({
		r: PropTypes.number,
		g: PropTypes.number,
		b: PropTypes.number
	}).isRequired
};

export default CompactFields;
